module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "日志",
      "visible": _vm.popRef,
      "width": "60%"
    },
    on: {
      "update:visible": function($event) {
        _vm.popRef = $event
      },
      "open": _vm.onDialogOpen
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.dt.data,
      "stripe": true,
      "border": "",
      "highlight-current-row": "",
      "size": _vm.dt.size
    },
    on: {
      "sort-change": _vm.dt.handleSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "property": "createdAt",
      "label": "时间",
      "min-width": "15%",
      "formatter": _vm.dateFormat,
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "modifyUser.staffName",
      "label": "操作人",
      "min-width": "15%",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "action",
      "label": "操作",
      "min-width": "30%",
      "sortable": "custom"
    }
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.dt.currentPage,
      "page-sizes": _vm.dt.pageSizes,
      "page-size": _vm.dt.pageSize,
      "layout": _vm.dt.layout,
      "total": _vm.dt.totalElements
    },
    on: {
      "size-change": _vm.dt.handleSizeChange,
      "current-change": _vm.dt.handleCurrentChange
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7398a1e6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/dialog/CommonLogListDialog.vue
// module id = 459
// module chunks = 2